import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-[#FF6600] text-white hover:bg-[#CC5200] focus-visible:ring-[#FF6600]',
    secondary: 'bg-[#00316B] text-white hover:bg-[#002255] focus-visible:ring-[#00316B]',
    outline: 'border border-[#0C0C0C] bg-transparent hover:bg-[#F3F4F6] text-[#0C0C0C] focus-visible:ring-[#0C0C0C]',
    ghost: 'hover:bg-[#F3F4F6] text-[#0C0C0C] hover:text-[#00316B]'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-732">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-733" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-734">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-735">{rightIcon}</span>}
    </button>;
}